import { render, staticRenderFns } from "./aiVip.vue?vue&type=template&id=ee69f698&scoped=true"
import script from "./aiVip.vue?vue&type=script&lang=js"
export * from "./aiVip.vue?vue&type=script&lang=js"
import style0 from "./aiVip.vue?vue&type=style&index=0&id=ee69f698&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee69f698",
  null
  
)

export default component.exports